// Site configuration for The Bourganization Institute landing page.
// WhatsApp number can be overridden by setting REACT_APP_WHATSAPP_NUMBER in frontend/.env
const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "17252765988"; // +1 (725) 276-5988
const WHATSAPP_TEXT = encodeURIComponent(
  "Hello, I would like to inquire about membership with The Bourganization Institute."
);

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_TEXT}`;

// Dedicated SMS ledger enrollment request via WhatsApp — prefilled with the member's
// explicit consent statement (A2P 10DLC opt-in evidence).
export const WHATSAPP_SMS_ENROLL_MESSAGE =
  "I request enrollment in BGNZN Institute ledger alert text messages at my mobile number. " +
  "I agree to receive transactional SMS payment confirmations from BGNZN Institute. " +
  "Message frequency varies. Msg & data rates may apply. Reply STOP to cancel, HELP for help. " +
  "Consent is not a condition of membership.";
export const WHATSAPP_SMS_ENROLL_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_SMS_ENROLL_MESSAGE
)}`;

// Verbatim double opt-in messages sent by the SMS gateway (keep in sync with backend server.py)
export const SMS_CONFIRMATION_MESSAGE =
  "BGNZN Institute: Reply YES to confirm you agree to receive ledger alerts via SMS at this number. " +
  "Msg frequency varies. Msg & data rates may apply. Reply STOP to cancel, HELP for help.";
export const SMS_ACTIVATION_MESSAGE =
  "BGNZN Institute: confirmed. Your device is now activated for ledger alerts. " +
  "Text SEND [amount] TO [member key] to transfer $sUSD. Reply STOP to cancel, HELP for help.";

// One-tap iOS text-to-pay deep link (opens Messages with the payment command prefilled)
export const SMS_PAY_URL = `sms:+${WHATSAPP_NUMBER}&body=${encodeURIComponent("SEND 50 TO SOVEREIGN_B")}`;
export const SMS_PAY_NUMBER = "+1 (725) 276-5988";

export const ORG = {
  name: "The BOURGANIZATION Institute, NGO",
};

export const LOGO_URL = "/assets/bgnzn-logo-large.png";

export const IMAGES = {
  hero: {
    url: "/assets/bear-sculpture-hero.jpg",
    alt: "The BGNZN bear mark as a physical black-and-gold sculpture on the council desk",
  },
  pillarHealth: {
    url: "/assets/gym-state-of-art.jpeg",
    alt: "State of the art Institute gymnasium with training equipment",
  },
  pillarCommunity: {
    url: "/assets/community-hub.jpg",
    alt: "Neighborhood food forest exchange hub — barter network, member dues, and shared abundance",
  },
  pillarEdification: {
    url: "/assets/img-7450.jpeg",
    alt: "Institute mentorship gathering in the gymnasium",
  },
  gallery1: {
    url: "https://images.pexels.com/photos/8761323/pexels-photo-8761323.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Mentor speaking to participants at a business seminar",
  },
  gallery2: {
    url: "https://images.pexels.com/photos/9870144/pexels-photo-9870144.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Handshake over contract documents at a trade exchange meeting",
  },
  gallery3: {
    url: "https://images.pexels.com/photos/6129868/pexels-photo-6129868.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Scientist conducting biomedical research in a laboratory",
  },
  gallery4: {
    url: "https://images.pexels.com/photos/4508751/pexels-photo-4508751.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Server racks in a private data center repository",
  },
  exchange: {
    url: "https://images.pexels.com/photos/37730212/pexels-photo-37730212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Autonomous banking servers and privatized ledger network",
  },
  directorAthletics: {
    url: "/assets/director-athletics.jpg",
    alt: "Professional basketball action — athletics and wellness directorship",
  },
  directorFinance: {
    url: "https://images.pexels.com/photos/7845349/pexels-photo-7845349.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Financial consultant reviewing documents at a private desk",
  },
  directorBiomed: {
    url: "https://images.pexels.com/photos/32213405/pexels-photo-32213405.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Biomedical researcher working with a microscope in the laboratory",
  },
  directorPsych: {
    url: "https://images.pexels.com/photos/9065249/pexels-photo-9065249.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    alt: "Psychological sciences mentor in a counseling session",
  },
  directorsManaging: {
    url: "/assets/directors/directors-banner.jpg",
    alt: "The BGNZN Directorship banner — Aharon, Miykhá, and Jalen Shepard in the house plaid",
  },
  jalenShepard: {
    url: "/assets/directors/jalen-shepard-plaid.webp",
    alt: "Jalen Shepard — BGNZN Managing Director of Sports Science & Analytics, in the house plaid",
  },
};

export const NAV_LINKS = [
  { href: "/guide", label: "Visitor Guide", testid: "nav-guide-link" },
  { href: "#mission", label: "Mission", testid: "nav-mission-link" },
  { href: "#pillars", label: "Three Pillars", testid: "nav-pillars-link" },
  { href: "#orchard", label: "Fruit Forests", testid: "nav-orchard-link" },
  { href: "/growlab", label: "Growlab", testid: "nav-growlab-link" },
  { href: "/vivarium", label: "Vivarium", testid: "nav-vivarium-link" },
  { href: "#natural-building", label: "Natural Building", testid: "nav-building-link" },
  { href: "#gallery", label: "Institute Gallery", testid: "nav-gallery-link" },
  { href: "/shop", label: "Shop", testid: "nav-shop-link" },
  { href: "#exchange", label: "Merchant Exchange", testid: "nav-exchange-link" },
  { href: "#directors", label: "Directorship", testid: "nav-directors-link" },
  { href: "#contact", label: "Membership", testid: "nav-membership-link" },
  { href: "https://secure.thebourg.co/ctf", label: "Core Banking Sign-In", testid: "nav-core-banking-link" },
];
